import { useEffect, useState } from 'react';
import { Address } from '@multiversx/sdk-core/out';
import { contractAddress } from 'config';

import { useGetNetworkConfig } from 'hooks';
import { getScController } from './smartContract';

export const useGetPingAmount = () => {
  const { network } = useGetNetworkConfig();
  const [pingAmount, setPingAmount] = useState<string>();

  const getPingAmount = async () => {
    try {
      const scController = getScController(network);

      const [result] = await scController.query({
        contract: Address.newFromBech32(contractAddress),
        function: 'getPingAmount',
        arguments: []
      });

      setPingAmount(result?.valueOf()?.toString(10));
    } catch (err) {
      console.error('Unable to call getPingAmount', err);
    }
  };

  useEffect(() => {
    getPingAmount();
  }, []);

  return pingAmount;
};
